import { truncate } from 'lodash';
import React from 'react';
import styled from 'styled-components';

// Components
import { IconActionClose } from 'wg-fe-ui';
import { SmtFile } from '../../../../../../../types/Form';

interface Props {
  file: SmtFile;
  onRemove: (arg0: string) => void;
}

const UploadFilePreview: React.FC<React.PropsWithChildren<Props>> = ({
  file,
  onRemove,
}) => {
  return (
    <Wrapper>
      <Label>
        {truncate(file.filename, {
          length: 32,
          separator: ' ',
        })}
      </Label>
      <CloseIconContainer onClick={() => file?.key && onRemove(file?.key)}>
        <IconActionClose />
      </CloseIconContainer>
    </Wrapper>
  );
};

const CloseIconContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

const Label = styled.p`
  font-weight: 500;
  font-size: 1.4rem;
`;

const Wrapper = styled.div`
  min-height: 3.2rem;
  width: 100%;
  border: 1px solid #e4e4e4;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.6rem;
  border-radius: 0.5rem;

  & + div {
    margin-top: 1.6rem;
  }

  &:hover {
    cursor: pointer;
  }
`;

export default UploadFilePreview;
